import { useSelector } from 'react-redux';

import { VALID_THEMES, DEFAULT_THEME } from 'Config/site-themes';

/**
 * Utility hook for selecting siteTheme from redux
 * @param  {String} override      Override value set in redux, useful for props on
 *                                components that set to always be light or dark
 * @return {String}               light|dark
 */
export default function useTheme(override) {
  const siteTheme = useSelector(state => state?.siteTheme) || DEFAULT_THEME;

  if (override && VALID_THEMES.includes(override)) {
    return override;
  }

  return siteTheme;
}

/**
 * Utility hook for selecting is light theme being used
 * @param  {Boolean} forceLightTheme     Override value set in redux, useful for props on
 *                                       components that set to always be light
 * @return {Boolean}
 */
export function useLightTheme(forceLightTheme) {
  const siteTheme = useTheme();

  if (forceLightTheme === true) {
    return forceLightTheme;
  }

  return siteTheme === 'light';
}

/**
 * Utility hook for selecting is dark theme being used
 * @param  {Boolean} forceDarkTheme     Override value set in redux, useful for props on
 *                                       components that set to always be dark
 * @return {Boolean}
 */
export function useDarkTheme(forceDarkTheme) {
  const siteTheme = useTheme();

  if (forceDarkTheme === true) {
    return forceDarkTheme;
  }

  return siteTheme === 'dark';
}
